export default __webpack_public_path__ + "static/media/Lounge 005.b9d4b3f2.jpg";